<template>
  <div>
    <div class="archive-head">
      <img src="../../assets/images/logo.png" alt="" />
    </div>
    <div class="nsfc-search-container">
      <section class="main-container">
        <section class="search-option card">
          <el-collapse v-model="activeNames">
            <el-collapse-item title="高级检索" name="search">
              <el-row :gutter="24">
                <el-col :span="16">
                  <p>
                    关键词：<span class="tips">（*多个关键词用空格隔开）</span>
                  </p>
                  <el-input v-model="searchOptions.keyword"></el-input>
                </el-col>
                <el-col :span="8">
                  <p>学科分类：</p>
                  <el-cascader
                    v-model="subjectType"
                    :options="subjectOptions"
                    :props="{
                      value: 'id',
                      label: 'label',
                      children: 'child',
                      expandTrigger: 'hover',
                    }"
                  ></el-cascader>
                </el-col>

                <el-col :span="8">
                  <p>批准年份：</p>
                  <div class="mul-option">
                    <el-date-picker
                      type="year"
                      v-model="searchOptions.approval_year"
                      :picker-options="pickerOptions"
                    >
                    </el-date-picker>
                    <p style="margin: 0 6px">-</p>
                    <el-date-picker
                      type="year"
                      v-model="searchOptions.end_year"
                      :picker-options="pickerOptions"
                    >
                    </el-date-picker>
                  </div>
                </el-col>
                <el-col :span="8">
                  <p>负责人：</p>
                  <el-input v-model="searchOptions.admin"></el-input>
                </el-col>
                <el-col :span="8">
                  <p>依托单位：</p>
                  <el-input v-model="searchOptions.unit"></el-input>
                </el-col>
                <!-- <el-col :span="8">
                  <p>资助金额（万元）：</p>
                  <div class="mul-option">
                    <el-input v-model="lowMoney"></el-input>
                    <p style="margin: 0 6px">-</p>
                    <el-input v-model="highMoney"></el-input>
                  </div>
                </el-col> -->
                <el-col :span="8">
                  <p>项目类别：</p>
                  <el-select
                    v-model="searchOptions.project_type"
                    clearable
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="item in taskOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-col>

                <el-col :span="16">
                  <p>&nbsp;</p>
                  <div style="text-align: right">
                    <el-button round @click="initData">清空</el-button>
                    <el-button type="primary" round @click="getSearchData"
                      >检索</el-button
                    >
                  </div>
                </el-col>
              </el-row>
            </el-collapse-item>
          </el-collapse>
        </section>
        <section class="chart-container card" v-show="this.chartData">
          <div id="main-chart"></div>
        </section>
        <section class="search-result card">
          <div class="result-header">
            <article>
              根据条件检索到
              <span style="color: #337ab7; font-weight: 500">{{ total }}</span>
              项
            </article>
            <div class="sort-block" v-if="resultList.length">
              <span class="tips">Sort By</span>
              <el-select
                v-model="searchOptions.order"
                placeholder="请选择"
                @change="handleSortChange"
              >
                <el-option
                  v-for="item in sortOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
              <div class="sort-icon-list" @click="handleSortOrderChange">
                <i class="el-icon-sort"></i>
                <i
                  class="desc-icon el-icon-sort-down"
                  v-show="searchOptions.sort === 'DESC'"
                ></i>
                <i
                  class="asc-icon el-icon-sort-up"
                  v-show="searchOptions.sort === 'ASC'"
                ></i>
              </div>
            </div>
          </div>
          <ul v-if="resultList.length">
            <li
              class="result-item card"
              :class="{ 'has-t-border': (index + 1) % pageSize === 1 }"
              v-for="(item, index) in resultList"
              :key="item.id"
            >
              <el-row
                type="flex"
                class="table-header"
                v-show="(index + 1) % pageSize === 1"
              >
                <el-col :span="4"> 负责人 </el-col>
                <el-col :span="6"> 依托单位 </el-col>
                <el-col :span="14"> 题目 </el-col>
              </el-row>
              <el-row type="flex" class="table-sub-header">
                <el-col :span="4">{{ item.projectAdmin }}</el-col>
                <el-col :span="6">{{ item.dependUnit }}</el-col>
                <el-col :span="14"
                  ><span class="click-title" @click="gotoDetails(item.id)">{{
                    item.projectName
                  }}</span></el-col
                >
              </el-row>
              <el-row type="flex">
                <el-col :span="4">学科代码</el-col>
                <el-col :span="20">{{
                  item.applyCode ? item.applyCode.code : ""
                }}</el-col>
              </el-row>
              <el-row type="flex">
                <el-col :span="4">项目类别</el-col>
                <el-col :span="20">{{ item.projectType }}</el-col>
              </el-row>
              <el-row type="flex">
                <el-col :span="4">资助经费（万元）</el-col>
                <el-col :span="20">{{ item.supportNum }}</el-col>
              </el-row>
              <el-row type="flex">
                <el-col :span="4">批准年份</el-col>
                <el-col :span="20">{{ item.approvalYear }}</el-col>
              </el-row>
              <el-row type="flex">
                <el-col :span="4">结题年份</el-col>
                <el-col :span="20">{{ item.endYear }}</el-col>
              </el-row>
              <el-row type="flex">
                <el-col :span="4">关键词</el-col>
                <el-col :span="20">{{ item.projectKeywordC.join(" ") }}</el-col>
              </el-row>
              <el-row type="flex">
                <el-col :span="4">结题摘要</el-col>
                <el-col :span="20">{{ item.projectAbstractC }}</el-col>
              </el-row>
            </li>
            <el-pagination
              background
              layout="prev, pager, next"
              :page-size="pageSize"
              :current-page="currentPage"
              :total="total"
              @current-change="handlePageChange"
              style="margin-top: 12px"
            >
            </el-pagination>
          </ul>
          <!-- <ul v-if="resultList.length">
            <li
              class="result-item card"
              v-for="(item, index) in resultList"
              :key="item.id"
            >
              <h2 @click="gotoDetails(item.id)">
                {{ (currentPage - 1) * pageSize + index + 1 }}.
                {{ item.projectName }}
              </h2>
              <el-row>
                <el-col :span="6">
                  <span class="label">学科代码：</span>
                  <span class="value">{{
                    item.applyCode ? item.applyCode.code : ""
                  }}</span>
                </el-col>
                <el-col :span="6">
                  <span class="label">学科分类：</span>
                  <span class="value">{{
                    item.applyCode ? item.applyCode.name : ""
                  }}</span>
                </el-col>
                <el-col :span="6">
                  <span class="label">项目类别：</span>
                  <span class="value">{{ item.projectType }}</span>
                </el-col>
                <el-col :span="6">
                  <span class="label">负责人：</span>
                  <span class="value">{{ item.projectAdmin }}</span>
                </el-col>
                <el-col :span="6">
                  <span class="label">依托单位：</span>
                  <span class="value">{{ item.dependUnit }}</span>
                </el-col>
                <el-col :span="6">
                  <span class="label">资助经费（万元）：</span>
                  <span class="value">{{ item.supportNum }}</span>
                </el-col>
                <el-col :span="6">
                  <span class="label">批准年份：</span>
                  <span class="value">{{ item.approvalYear }}</span>
                </el-col>
                <el-col :span="6">
                  <span class="label">结题年份：</span>
                  <span class="value">{{ item.endYear }}</span>
                </el-col>
                <el-col :span="24">
                  <span class="label">关键词：</span>
                  <span class="value">{{
                    item.projectKeywordC.join(" ")
                  }}</span>
                </el-col>
                <el-col :span="24" v-if="item.projectAbstractC">
                  <span class="label">结题摘要：</span>
                  <span class="value">{{ item.projectAbstractC }}</span>
                </el-col>
              </el-row>
            </li>
            <el-pagination
              background
              layout="prev, pager, next"
              :page-size="pageSize"
              :current-page="currentPage"
              :total="total"
              @current-change="handlePageChange"
            >
            </el-pagination>
          </ul> -->
        </section>
      </section>
    </div>
  </div>
</template>
<script>
import echarts from "echarts";
import { getSubjecList, getSearchData, getSearchChart } from "@/api/nsfc";
export default {
  data() {
    return {
      activeNames: ["search"],
      searchOptions: {
        keyword: "",
        unit: "",
        admin: "",
        approval_year: "",
        end_year: "",
        project_type: "",
        subject_code: "",
        order: "endYear",
        sort: "DESC",
      },
      subjectType: [],
      lowMoney: "",
      highMoney: "",
      total: 0,
      pageSize: 10,
      currentPage: 1,
      taskOptions: [
        {
          value: "面上项目",
          label: "面上项目",
        },
        {
          value: "重点项目",
          label: "重点项目",
        },
        {
          value: "专项基金项目",
          label: "专项基金项目",
        },
        {
          value: "联合基金项目",
          label: "联合基金项目",
        },
        {
          value: "重大研究计划",
          label: "重大研究计划",
        },
        {
          value: "青年科学基金项目",
          label: "青年科学基金项目",
        },
        {
          value: "地区科学基金项目",
          label: "地区科学基金项目",
        },
        {
          value: "数学天元基金项目",
          label: "数学天元基金项目",
        },
      ],
      yearOptions: [],
      subjectOptions: [],
      sortOptions: [
        {
          value: "approvalYear",
          label: "批准年份",
        },
        {
          value: "endYear",
          label: "结题年份",
        },
        {
          value: "supportNum",
          label: "资助经费",
        },
      ],
      pickerOptions: {
        disabledDate(time) {
          return time.getFullYear() < 1986 || time.getFullYear() > 2020;
        },
      },
      resultList: [],
      myChart: null,
      chartData: null
    };
  },
  computed: {
    support_num() {
      return `${this.lowMoney || 0} ${this.highMoney || 0}`;
    },
  },
  mounted() {
    this.getSubjecList();
  },
  methods: {
    initData() {
      (this.searchOptions = {
        keyword: "",
        unit: "",
        admin: "",
        approval_year: "",
        end_year: "",
        project_type: "",
        subject_code: "",
        order: "endYear",
        sort: "DESC",
      }),
        (this.subjectType = []);
      this.lowMoney = "";
      this.highMoney = "";
    },
    gotoDetails(id) {
      this.$router.push({
        name: "nsfc-s-details",
        query: {
          id,
        },
      });
    },
    getSubjecList() {
      getSubjecList().then((res) => {
        const data = res.data.data;
        this.subjectOptions = this.handleSubjectData(data);
      });
    },
    handleSubjectData(data) {
      let subjectList = [];
      for (let i in data) {
        data[i].label = `${data[i].id} ${data[i].name}`;
        if (data[i].child && data[i].child.length > 0) {
          this.handleSubjectData(data[i].child);
        }
        subjectList.push(data[i]);
      }
      return subjectList;
    },
    getSearchData() {
      if (!this.searchOptions.keyword && !this.searchOptions.admin) {
        this.$message({
          message: "请输入关键词或负责人后再搜索",
          type: "warning",
        });
        return;
      }
      this.getChartData()
      const params = this.handleSearchParams();
      getSearchData(params).then((res) => {
        this.resultList = res.data.data || [];
        this.total = res.data.total;
        window.scrollTo(0, 0);
      });
    },
    handleSearchParams() {
      let params = {
        page: this.currentPage,
        pagesize: this.pageSize,
      };
      if (this.subjectType.length) {
        this.searchOptions.subject_code =
          this.subjectType[this.subjectType.length - 1];
      }
      if (this.lowMoney || this.highMoney) {
        this.searchOptions.support_num = this.support_num;
      }
      for (let key in this.searchOptions) {
        const value = this.searchOptions[key];
        if ((key === "approval_year" || key === "end_year") && value) {
          params[key] = new Date(value).getFullYear();
        } else if (value) {
          params[key] = value;
        }
      }
      return params;
    },
    handlePageChange(page) {
      this.currentPage = page;
      this.getSearchData();
    },
    handleSortChange() {
      this.getSearchData();
    },
    handleSortOrderChange() {
      const sort = this.searchOptions.sort === "DESC" ? "ASC" : "DESC";
      this.$set(this.searchOptions, "sort", sort);
      this.getSearchData();
    },
    getChartData() {
      const keywordList = this.searchOptions.keyword.split(' ')
      const keyword = keywordList.join(',')
      getSearchChart(keyword).then((response) => {
        console.log("response", response);
        const data = response.data.data;
        if (data.length) {
          this.chartData = this.handleChartData(data);
          this.$nextTick(() => {
            setTimeout(() => {
              this.initCharts(this.chartData)
            })
          })
        } else {
        }
      });
      //   this.initCharts(data);
    },
     handleChartData(data) {
      const trend = data[0].trend;
      const xAxis = trend.map((i) => i.year) || [];
      const seriesData = [];
      data.forEach((item) => {
        seriesData.push({
          name: item.keyword,
          type: "line",
          showSymbol: false,
          data: item.trend.map((i) => i.count),
        });
      });
      return {
        seriesData,
        xAxis,
      };
    },
    initCharts(data) {
      if (this.myChart) {
        this.myChart.clear();
      }
      const chartDom = document.getElementById("main-chart");
      this.myChart = echarts.init(chartDom);
      const option = {
        tooltip: {
          trigger: "axis",
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        toolbox: {
          feature: {
            saveAsImage: {},
          },
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: data.xAxis,
        },
        yAxis: {
          type: "value",
        },
        series: data.seriesData,
      };
      this.myChart.setOption(option);
    },
  },
};
</script>
<style lang="less">
.nsfc-search-container {
  .el-collapse-item__header,
  .el-collapse-item__wrap {
    border: none;
  }
  .el-collapse-item__header {
    color: #337ab7;
    font-size: 18px;
  }
  .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #337ab7 !important;
  }
  .el-pagination {
    text-align: center;
  }
}
</style>
<style lang="less" scoped>
* {
  box-sizing: border-box;
}
.archive-head {
  width: 100%;
  background-color: #0275d8;
  color: white;
  font-size: 16px;
  height: 50px;
  padding: 10px 15px;
  img {
    width: 100px;
  }
}
.nsfc-search-container {
  background: #f0f2f5;
  padding: 20px;
  min-height: calc(100vh - 50px);
  .main-container {
    margin: auto;
    max-width: 1440px;
    min-width: 1080px;
    #main-chart {
      width: 100%;
      height: 500px;
    }
  }
  .el-collapse {
    border: none;
    padding: 6px 18px;
  }
  .card {
    background: #fff;
    border-radius: 5px;
    overflow: hidden;
  }
  .el-row {
    .el-col {
      margin-bottom: 18px;
      p {
        margin-bottom: 4px;
        font-size: 14px;
        color: #303030;
      }
      .tips {
        font-size: 12px;
        font-style: oblique;
        color: rgb(120, 120, 120);
      }
      .el-select,
      .el-cascader {
        width: 100%;
      }
    }
  }
  .mul-option {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .chart-container {
    margin: 32px 0;
  }
  .search-result {
    padding: 20px;
    // background: #e0e6f0;
    margin: 32px 0;
    .result-header {
      font-size: 14px;
      margin-bottom: 6px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .sort-block {
        display: flex;
        justify-content: space-between;
        align-items: center;
        .el-select {
          width: 120px;
        }
        .tips {
          margin-right: 4px;
        }
        .sort-icon-list {
          margin-left: 12px;
          position: relative;
          i {
            font-size: 16px;
            cursor: pointer;
          }
          .desc-icon,
          .asc-icon {
            position: absolute;
            color: #2e90e4;
            top: 1px;
            font-weight: 900;
          }
          .desc-icon {
            right: 2px;
          }
          .asc-icon {
            right: -4px;
          }
        }
      }
    }
    .result-item {
      // padding: 18px;
      // padding: 8px 0;
      font-size: 14px;
      // margin-bottom: 18px;

      border-left: 1px solid #bbb;
      border-radius: 0;
      &.has-t-border {
        border-top: 1px solid #bbb;
      }
      h2 {
        font-size: 15px;
        color: #337ab7;
        margin-bottom: 6px;
        &:hover {
          cursor: pointer;
          text-decoration: underline;
        }
      }
      .el-row,
      .el-col {
        margin: 0;
        line-height: 24px;
      }
      .el-col {
        padding: 2px 6px;
        border-bottom: 1px solid #bbb;
        border-right: 1px solid #bbb;
      }
      .table-header {
        background: #337ab7;
        color: #fff;
      }
      .table-sub-header {
        background: #ddd;
      }
      .click-title {
        &:hover {
          text-decoration: underline;
          cursor: pointer;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/nsfcSearch/index.vue